<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { mdiInformation } from "@mdi/js"
    import Icon from "../../widgets/Icon.svelte"
    import { tooltip } from "../../../helper"
    import { _ } from "svelte-i18n"
    import Checkbox from "../../widgets/Checkbox.svelte"
    import NumberField from "../../widgets/fields/NumberField.svelte"

    export let advanceShippingNotice: { type: string; phone: string; name: string; costs: number }
    export let avisChecked: boolean = false

    let dispatch = createEventDispatcher()

    const toggleAdvanceShippingNotice = (checked: boolean) => {
        dispatch("toggle", checked)
        advanceShippingNotice = {
            type: "phone",
            phone: "",
            name: "",
            costs: 0,
        }
        dispatch("update", { advanceShippingNotice })
        avisChecked = checked
    }

    const resetAdvanceShippingNotice = () => {
        advanceShippingNotice = {
            type: "phone",
            phone: "",
            name: "",
            costs: 0,
        }
    }

    if (!advanceShippingNotice) {
        resetAdvanceShippingNotice()
    } else {
        if (advanceShippingNotice?.phone || advanceShippingNotice?.name) {
            avisChecked = true
        }
    }

    $: if (advanceShippingNotice) {
        if (advanceShippingNotice?.phone || advanceShippingNotice?.name) {
            avisChecked = true
        }
    }

    $: if (!advanceShippingNotice) {
        resetAdvanceShippingNotice()
    }
</script>

<div
    class="cart-avis-form"
    class:invalid="{avisChecked && (advanceShippingNotice?.name === '' || advanceShippingNotice?.phone === '')}"
>
    <div class="row">
        <div class="col-md-4">
            <Checkbox
                label="{$_('cart.phoneNotificationRequested')}"
                on:checked="{() => toggleAdvanceShippingNotice(true)}"
                on:unchecked="{() => toggleAdvanceShippingNotice(false)}"
                checked="{avisChecked}"
            >
                <div
                    use:tooltip="{{
                        content: $_('cart.costNotice'),
                    }}"
                    class="layout align-items-center"
                >
                    <Icon path="{mdiInformation}" size="24px" />
                </div>
            </Checkbox>
        </div>
        <div class="col-md-2">
            <input
                on:input="{() => dispatch('update', { advanceShippingNotice })}"
                type="text"
                placeholder="{$_('cart.phoneNotification')}"
                name="avis-telefon"
                disabled="{!avisChecked}"
                class:invalid="{advanceShippingNotice?.phone === ''}"
                bind:value="{advanceShippingNotice.phone}"
                maxlength="20"
            />
        </div>
        <div class="col-md-4">
            <input
                type="text"
                name="avis-name"
                on:input="{() => dispatch('update', { advanceShippingNotice })}"
                placeholder="Avis-Name"
                disabled="{!avisChecked}"
                class:invalid="{advanceShippingNotice?.name === ''}"
                bind:value="{advanceShippingNotice.name}"
                maxlength="20"
            />
        </div>
        <div
            class="col-md-2 layout alignt-items-center justify-content-end"
            style="justify-content: flex-end !important;"
        >
            <div class="layout justify-content-start align-items-center" style="width: 80px;">
                {#if avisChecked}
                    <NumberField value="{advanceShippingNotice?.costs}" decimals="{2}" /> €
                {:else}
                    <NumberField value="{0}" decimals="{2}" /> €
                {/if}
            </div>
            <div style="width: 150px; height: 10px;"></div>
        </div>
    </div>
</div>
